import api from '@shared/services/api';

export const sellerInvestmentService = {
    getByEmpIdAndTypeActivity: async (empId, typeActivity) => {
        const response = await api.get(`/seller-investment/${empId}?typeActivity=${typeActivity}`);
        return response.data || [];
    },
    create: async (data) => {
        const response = await api.post('/seller-investment', data);
        return response.data;
    },
    update: async (id, data) => {
        const response = await api.put(`/seller-investment/${id}`, data);
        return response.data;
    },
    delete: async (id) => {
        const response = await api.delete(`/seller-investment/${id}`);
        return response.data;
    },
};

